import { ValueOf } from 'src/models/types/utility-types';

// src\app\services\imports\import.service-v3.ts
export const ImportServiceV3LoadingKeys = {
  Default: 'import-page',
  // Key não está sendo usado
  ImportErrorTable: 'import-page-error-table'
} as const;

export type ImportServiceV3LoadingKey = ValueOf<typeof ImportServiceV3LoadingKeys>;
